import React from "react";
import "../style.scss";

const BlurredString = ({ state, str }) => {
  return <>{state !== "LOADED" ? <span className="blur">Ensuro</span> : <span>{str}</span>}</>;
};

export default BlurredString;
